<template>
    <div class="publication__editor">

        <div class="publication__editor-wrap  d-flex">
            <div class="publication__editor-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">{{$store.getters.t('facilities_store_form_title')}}</div>
                    <div class="publication__fieldset-input">
                        <input type="text" v-model="$v.name.$model" :placeholder="$store.getters.t('facilities_store_form_title')">
                    </div>
                    <div class="text-danger" v-show="$v.name.$error">{{$store.getters.t('facilities_store_form_enter_title')}}</div>
                </div>
                <div class="publication__fieldset publication__fieldset--textarea-large">
                    <div class="publication__fieldset-title">{{$store.getters.t('facilities_store_form_description')}}</div>
                    <div class="publication__fieldset-input">
                        <textarea v-model="$v.description.$model" :placeholder="$store.getters.t('facilities_store_form_description')"></textarea>
                    </div>
                    <div class="text-danger" v-show="$v.description.$error">{{$store.getters.t('facilities_store_form_description_min')}}</div>
                </div>
            </div>
            <div class="publication__editor-item">

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('facilities_store_form_category')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.giveaway_categories">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.giveaway_category.$model" :value="key">
                                <span class="circle"></span>
                                {{$store.getters.t(key === 'medical' ? 'facilities_store_form_medical' : (key === 'nutrition' ? 'facilities_store_form_nutrition' : (key === 'other' ? 'facilities_store_form_other' : 'common_unknown')))}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.giveaway_category.$error">{{$store.getters.t('facilities_store_form_choose_category')}}</div>

                </div>


                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('facilities_store_form_availability')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.ranges">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.range.$model" :value="key">
                                <span class="circle"></span>
                                {{$store.getters.t(key === 'city' ? 'facilities_store_form_city' : (key === 'region' ? 'facilities_store_form_region' : (key === 'country' ? 'facilities_store_form_country' : (key === 'abroads' ? 'facilities_store_form_abroad' : 'common_unknown'))))}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.range.$error">{{$store.getters.t('facilities_store_form_enter_availability')}}</div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>

import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";
export default {
    name: "GiveAwayHelpForm",
    props: ['server'],
    mixins: [ StateMixin ],
    computed:{

        serverDictionary(){ return this.server.dictionaries },

        name: {
            get() { return this.GET_BY_KEY('name') },
            set( val ) {
                this.SET_BY_KEY({key: 'name', data: val})
            }
        },

        description: {
            get() { return this.GET_BY_KEY('description') },
            set( val ) {
                this.SET_BY_KEY({key: 'description', data: val})
            }
        },

        giveaway_category: {
            get() { return this.GET_BY_KEY('giveaway_category') },
            set( val ) {
                this.SET_BY_KEY({key: 'giveaway_category', data: val})
            }
        },

        range: {
            get() { return this.GET_BY_KEY('range') },
            set( val ) {
                this.SET_BY_KEY({key: 'range', data: val})
            }
        },

    },

    methods:{
        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true

        }
    },

    validations: {
        name:                { required },
        giveaway_category: { required },
        range:               { required },
        description:         { required, minLength: minLength(30), maxLength: maxLength(3000) },
    }


}
</script>

<style scoped>

</style>
